import { useState, useCallback } from 'react';
import { storage } from '../../../../../firebase';
import { ref, getDownloadURL } from 'firebase/storage';

interface UseDocumentDownloadReturn {
  downloading: string | null;
  downloadDocument: (storagePath: string, type: string, applicationName?: string) => Promise<void>;
  error: string | null;
  setError: React.Dispatch<React.SetStateAction<string | null>>;
}

export const useDocumentDownload = (): UseDocumentDownloadReturn => {
  const [downloading, setDownloading] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const downloadDocument = useCallback(async (storagePath: string, type: string, applicationName?: string) => {
    let blobUrl: string | null = null;

    try {
      setDownloading(type);
      setError(null);

      const storageRef = ref(storage, storagePath);
      const downloadUrl = await getDownloadURL(storageRef);

      // 파일 확장자 추출
      const extension = storagePath.split('.').pop() || 'pdf';

      // 파일 다운로드
      const response = await fetch(downloadUrl);
      const blob = await response.blob();
      blobUrl = window.URL.createObjectURL(blob);

      // 다운로드 링크 생성 및 클릭
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = applicationName
        ? `${applicationName}_${type}.${extension}`
        : `document_${type}.${extension}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error('파일 다운로드 중 오류 발생:', err);
      setError('파일 다운로드 중 오류가 발생했습니다.');
    } finally {
      // Blob URL 정리 (메모리 누수 방지)
      if (blobUrl) {
        window.URL.revokeObjectURL(blobUrl);
      }
      setDownloading(null);
    }
  }, []);

  return {
    downloading,
    downloadDocument,
    error,
    setError
  };
};
